import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../../components/landing"
import { payGuideZh } from "../../content/zh/pay-calculator"
import { guideSeo } from "../guides.$slug"

const PATH = "/pay-calculator"

/** Chinese version of /pay-calculator (D-WEB-LANG-SCOPE, T1321); the English route carries the hreflang pair too. */
export const payZhSeo = () => guideSeo(payGuideZh, PATH, "zh")

export const Route = createFileRoute("/_brand-layout/zh/pay-calculator")({
  head: () => {
    const { meta, links, scripts } = payZhSeo()
    return { meta, links, scripts }
  },
  component: PayZhPage,
})

export function PayZhPage() {
  return <GuidePage guide={payGuideZh} />
}
